import { Button, ButtonGroup } from '@material-ui/core';
import React, { useCallback, useMemo } from 'react';
import styled from 'styled-components/macro';
import { useSelector, useDispatch } from 'react-redux';
import { showBulkActionBarSelector } from 'store/selectors/ticket-group-table.selector';
import { manualSiActions } from 'store/actions/manual-si.actions';
import {
  assignUnassignActions,
  ticketGroupTableActions,
} from 'store/actions';

//bulk actions
import { ReactComponent as AssignIcon } from 'assets/images/bulk-action-icons/assign-icon.svg';
import { ReactComponent as UnassignIcon } from 'assets/images/bulk-action-icons/unassign-icon.svg';
import { ReactComponent as MarkSiIcon } from 'assets/images/bulk-action-icons/si-icon.svg';
import { ReactComponent as MarkNonSiIcon } from 'assets/images/bulk-action-icons/non-si-icon.svg';
import {
  showAssignUnassignButtonSelector,
  showMarkSiNonSiSelector,
} from 'store/selectors/workdesk-filter.selector';

const BulkActionBar: React.FC = () => {
  const showBulkActionBar = useSelector(showBulkActionBarSelector);
  const dispatch = useDispatch();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const stableDispatch = useCallback(dispatch, []);
  const {
    assign: showAssignButton,
    unassign: showUnassignButton,
  } = useSelector(showAssignUnassignButtonSelector);
  const { markSi, markNonSi } = useSelector(showMarkSiNonSiSelector);

  const buttonsInfo = useMemo(() => {
    let buttons = [] as any[];
    if (showAssignButton) {
      buttons = buttons.concat({
        label: 'Assign to me',
        Icon: AssignIcon,
        onClick: () => {
          stableDispatch(
            assignUnassignActions.postAssignOfSelectedTicketIds(),
          );
        },
      });
    }
    if (showUnassignButton) {
      buttons = buttons.concat({
        label: 'Unassign',
        Icon: UnassignIcon,
        onClick: () => {
          stableDispatch(
            assignUnassignActions.postUnassignOfSelectedTicketIds(),
          );
        },
      });
    }
    if (markSi) {
      buttons = buttons.concat([
        {
          label: 'Mark SI',
          Icon: MarkSiIcon,

          onClick: () => {
            stableDispatch(
              manualSiActions.postMarkSiOfSelectedTicketIds(true),
            );
            stableDispatch(
              ticketGroupTableActions.resetTicketGroupTableState(),
            );
          },
        },
      ]);
    }
    if (markNonSi) {
      buttons = buttons.concat([
        {
          label: 'Mark Non SI',
          Icon: MarkNonSiIcon,

          onClick: () => {
            stableDispatch(
              manualSiActions.postMarkSiOfSelectedTicketIds(false),
            );
            stableDispatch(
              ticketGroupTableActions.resetTicketGroupTableState(),
            );
          },
        },
      ]);
    }
    return buttons;
  }, [
    showAssignButton,
    showUnassignButton,
    markSi,
    markNonSi,
    stableDispatch,
  ]);

  return (
    <SButtonGroup
      className={!showBulkActionBar ? 'hide' : ''}
      variant="text"
      color="primary"
    >
      {buttonsInfo.map((item) => (
        <SButton
          key={item.label}
          startIcon={<item.Icon />}
          onClick={item.onClick}
        >
          {item.label}
        </SButton>
      ))}
    </SButtonGroup>
  );
};

export default BulkActionBar;
const SButton = styled(Button)`
  &.MuiButton-root {
    min-width: fit-content;
    white-space: nowrap;
    padding: 2px 10px;
    font-size: ${(props) => props.theme.typography.fontSize.small};
    font-weight: ${(props) =>
      props.theme.typography.fontWeight.regular};
    background: ${(props) => props.theme.palette.background.default};
    &:hover {
      box-shadow: 0px 0px 12px rgba(156, 156, 156, 0.27);
      background: ${(props) =>
        props.theme.palette.background.default};
      text-decoration: underline;
    }
  }
`;

const SButtonGroup = styled(ButtonGroup).attrs((props) => ({
  className: props.className,
}))`
  height: 30px;
  &.hide {
    width: 0;
    height: 0;
    overflow: hidden;
  }
`;
